<template>
    <!-- 服务咨询 -->
    <div class="page-container" style="padding-bottom:0px">
        <el-row type="flex" justify="space-between">
            <el-col :span="12" class="content-panel right">
                <el-row>
                    <h3 class="text-title">港中旅华贸国际物流股份有限公司上海海运部</h3>
                </el-row>
                <el-row>
                    <p class="font-color">优势产品</p>
                </el-row>
                <el-row>
                    <p class="font-color">上海所有船东的集装箱运价产品及后续订舱一条龙服务</p>
                </el-row>
                <el-row>
                    <p>主推航线</p>
                </el-row>
                <el-row>
                    <p>欧地非洲航线、中东印巴红海、东南亚</p>
                </el-row>
                <el-row>
                    <p>联系方式：仲逸平 021-63586199（进口业务）等</p>
                </el-row>
                <el-row type="flex" justify="end" style="margin-top:30px">
                    <p class="view-more" @click="handleViewMore">查看更多 >></p>
                </el-row>
            </el-col>
            <el-col :span="12" class="content-panel left">
                <el-row>
                    <h3 class="text-title">港中旅华贸国际物流股份有限公司上海空运部</h3>
                </el-row>
                <el-row>
                    <p class="font-color">优势产品</p>
                </el-row>
                <el-row>
                    <p class="font-color">空运进口业务、空运出口业务</p>
                </el-row>
                <el-row>
                    <p>主推航线</p>
                </el-row>
                <el-row>
                    <p>欧洲线：CZ/CA/CK/LH/RU/Y8/MU/TK/7L/3V/OZ/KL<br>美线：CZ/CA/CK/PO/UA/CI/ET/UC/Y8/SQ/OZ/CX<br>中东非线：TK/SQ/EK/7L/CX...</p>
                </el-row>
                <el-row>
                    <p>联系方式：张音 021-68353706 （进口副经理）等</p>
                </el-row>
                <el-row type="flex" justify="end">
                    <p class="view-more"  @click="handleViewMore2">查看更多 >></p>
                </el-row>
            </el-col>
        </el-row>
        <el-row type="flex" justify="space-between" style="margin-top:20px">
            <el-col :span="12" class="content-panel right">
                <el-row>
                    <h3 class="text-title" >港中旅华贸国际物流股份有限公司宁波公司</h3>
                </el-row>
                <el-row>
                    <p class="font-color">优势产品</p>
                </el-row>
                <el-row>
                    <p class="font-color">空运、海运、关务、仓储物流和跨境电商</p>
                </el-row>
                <el-row>
                    <p>联系方式：韩   娇 0574-88272105  hanjiao.nb@ctsfreight.com（关务,仓储）<br>
                    于   淼 0574-88156126 yumiao.nb@ctsfreight.com（跨境电商）<br>
                    邵丽丽 0574-88156031  shaoll.nb@ctsfreight.com （空运航线）<br>
                    庞智斌 0574-89089659 jimmypang.nb@ctsfreight.com  （海运）<br>
                    张翠环 0574-88156061  op1.nb@ctsfreight.com（海运）</p>
                </el-row>
                <el-row type="flex" justify="end" style="margin-top:30px">
                    <p class="view-more"  @click="handleViewMore3">查看更多 >></p>
                </el-row>
            </el-col>
            <el-col :span="12" class="content-panel left">
                <el-row>
                    <h3 class="text-title">港中旅华贸国际物流股份有限公司杭州分公司</h3>
                </el-row>
                <el-row>
                    <p class="font-color">优势产品</p>
                </el-row>
                <el-row>
                    <p class="font-color">空运、海运、报关</p>
                </el-row>
                <el-row>
                    <p>主推航线</p>
                </el-row>
                <el-row>
                    <p>空运优势航线：中东线、澳洲线、欧洲线、越南线、东南亚线；<br>
                        海运优势航线：地中海北非黑海航线、东南亚近洋航线..
                    </p>
                </el-row>
                <el-row>
                    <p>联系方式：下沙办公室 0571-87902326/87901628 等</p>
                </el-row>
                <el-row type="flex" justify="end" style="margin-top:30px">
                    <p class="view-more"  @click="handleViewMore4">查看更多 >></p>
                </el-row>
            </el-col>
        </el-row>
      <el-dialog
        title=""
        :visible.sync="infoDialogVisible"
        width="50%"
      >
        <el-row>
          <h3 class="text-title">港中旅华贸国际物流股份有限公司上海海运部</h3>
        </el-row>
        <el-row>
          <p class="font-color">优势产品</p>
        </el-row>
        <el-row>
          <p class="font-color">上海所有船东的集装箱运价产品及后续订舱一条龙服务</p>
        </el-row>
        <el-row>
          <p>主推航线</p>
        </el-row>
        <el-row>
          <p>欧地非洲航线、中东印巴红海、东南亚</p>
        </el-row>
        <el-row>
          <p>经营特色</p>
        </el-row>
        <el-row>
          <p>行业顶尖的海运平台，包括运价平台、订舱平台、关务平台。及项目物流、合同物流、仓储、铁路、 国内运输、跨境/国内货运</p>
        </el-row>
        <el-row>
          <p>经营地址：上海市上海市南京西路338号天安中心20楼</p>
        </el-row>
        <el-row>
          <p>联系方式：<br>仲逸平 021-63586199 oscar.zhong@ctsfreight.com（进口业务）<br>
            潘欣荣 13601625558 bill.pan@ctsfreight.com（销售负责人）<br>
            邓骁魏 021-63585506jimmy.deng@ctsfreight.com（市场运价负责人）<br>
            褚晓雷 18721293608 chuxl@ctsfreight.com（市场运价负责人）<br>
            费    佳 021-63582506 fiona.fei@ctsfreight.com （订舱负责人）<br>
            张    柳 021-63582150 stella.zhang@ctsfreight.com（订舱负责人）<br>
            张    齐 021-63582063 qi.zhang@ctsfreight.com（订舱负责人）
          </p>
        </el-row>
      </el-dialog>
      <el-dialog
        title=""
        :visible.sync="infoDialogVisible2"
        width="50%"
      >
        <el-row>
          <h3 class="text-title">港中旅华贸国际物流股份有限公司上海空运部</h3>
        </el-row>
        <el-row>
          <p class="font-color">优势产品</p>
        </el-row>
        <el-row>
          <p class="font-color">空运进口业务、空运出口业务</p>
        </el-row>
        <el-row>
          <p>主推航线</p>
        </el-row>
        <el-row>
          <p>欧洲线：CZ/CA/CK/LH/RU/Y8/MU/TK/7L/3V/OZ/KL<br>美线：CZ/CA/CK/PO/UA/CI/ET/UC/Y8/SQ/OZ/CX<br>中东非线：TK/SQ/EK/7L/CX...</p>
        </el-row>
        <el-row>
          <p>经营特色</p>
        </el-row>
        <el-row>
          <p>行业顶尖的海运平台，包括运价平台、订舱平台、关务平台。及项目物流、合同物流、仓储、铁路、 国内运输、跨境/国内货运</p>
        </el-row>
        <el-row>
          <p>经营地址：上海市上海市南京西路338号天安中心20楼</p>
        </el-row>
        <el-row>
          <p>联系方式：张音 021-68353706 （进口副经理）等</p>
        </el-row>
      </el-dialog>
      <el-dialog
        title=""
        :visible.sync="infoDialogVisible3"
        width="50%"
      >
        <el-row>
          <h3 class="text-title" >港中旅华贸国际物流股份有限公司宁波公司</h3>
        </el-row>
        <el-row>
          <p class="font-color">优势产品</p>
        </el-row>
        <el-row>
          <p class="font-color">空运、海运、关务、仓储物流和跨境电商</p>
        </el-row>
        <el-row>
          <p>联系方式：韩   娇 0574-88272105  hanjiao.nb@ctsfreight.com（关务,仓储）<br>
            于   淼 0574-88156126 yumiao.nb@ctsfreight.com（跨境电商）<br>
            邵丽丽 0574-88156031  shaoll.nb@ctsfreight.com （空运航线）<br>
            庞智斌 0574-89089659 jimmypang.nb@ctsfreight.com  （海运）<br>
            张翠环 0574-88156061  op1.nb@ctsfreight.com（海运）</p>
        </el-row>
      </el-dialog>
      <el-dialog
        title=""
        :visible.sync="infoDialogVisible4"
        width="50%"
      >
        <el-row>
          <h3 class="text-title">港中旅华贸国际物流股份有限公司杭州分公司</h3>
        </el-row>
        <el-row>
          <p class="font-color">优势产品</p>
        </el-row>
        <el-row>
          <p class="font-color">空运、海运、报关</p>
        </el-row>
        <el-row>
          <p>主推航线</p>
        </el-row>
        <el-row>
          <p>空运优势航线：中东线、澳洲线、欧洲线、越南线、东南亚线；<br>
            海运优势航线：地中海北非黑海航线、东南亚近洋航线..
          </p>
        </el-row>
        <el-row>
          <p>联系方式：下沙办公室 0571-87902326/87901628 等</p>
        </el-row>
      </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            infoDialogVisible: false,
            infoDialogVisible2: false,
            infoDialogVisible3: false,
            infoDialogVisible4: false,
        };
    },
    async created() {

    },
    mounted() {

    },
    methods: {
        handleViewMore() {
            this.infoDialogVisible = true
        },
        handleViewMore2() {
         this.infoDialogVisible2 = true
        },
        handleViewMore3() {
          this.infoDialogVisible3 = true
        },
        handleViewMore4() {
          this.infoDialogVisible4 = true
        }

    }
};
</script>

<style scoped lang="scss">
.right {
  margin-right: 10px;
}
.left {
  margin-left: 10px;
}
.text-title {
  text-align: center;
}
p {
  margin: 4px 0px;
  font-size: 13px;
}
.font-color {
  color: #3366FF;
}
.view-more {
  cursor: pointer;
}
</style>
